import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import Pagination from 'components/Common/newPagination';
import ReleaseService from './ReleaseService';
import ReleaseLinkDetails from './ReleaseLinkDetails';

export default function ReleaseLinking(param: any) {
    console.log(param)

    let [searchFor, setSearchFor] = useState("");
    let [selectSplit, setselectSplit] = useState("");
    let [freezeAsset, setfreezeAsset] = useState(false)
    let [selectedValue, setSelectedValue] = useState<any>([]);
    let [mainContractCount, setMainContractCount] = useState(0);
    let [selectcontractSplit, setselectcontractSplit] = useState(0);
    let [mainContractList, setMainContractList] = useState<any>([]);
    let [mainContractTempList, setMainContractTempList] = useState<any>([]);
    let [ReleaseLinkDetailOpen, setReleaseLinkDetailOpen] = useState(false);
    const [editModeReleaseSplits, seteditModeReleaseSplits] = useState(false);


    const closeDrawer = () => { param.onChangReleaseLinking(); }
    const Data: any = { pageNumber: 1, pageSize: 10 }

    useEffect(() => {
        if (param.ReleaseLinkingOpen) {
            apiCall();
        }
    }, []);

    const apiCall = () => {
        ReleaseService.getMainContracts({ contractRefNum: param?.contractDetails?.contractRefNum }).then((respond: any) => {
            //mainContractList = respond
            mainContractList = respond.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber));

            setMainContractList(mainContractList)

            mainContractTempList = respond
            setMainContractTempList(mainContractTempList)

            mainContractCount = respond?.length ?? 0
            setMainContractCount(mainContractCount)
        })
    }

    const editSplit = (mapValue: any) => {

        selectcontractSplit = mapValue?.contractSplit
        setselectcontractSplit(selectcontractSplit)
        seteditModeReleaseSplits(!editModeReleaseSplits);

        selectSplit = selectSplit == mapValue?.splitId ? "" : mapValue?.splitId
        setselectSplit(selectSplit)
    }

    const saveReleaseSplitsSlider = (contractAssociatedRelease: any) => {

        var payload = contractAssociatedRelease

        payload.contractSplit = Number(selectcontractSplit);

        ReleaseService.mainContractsSave(payload).then((respond: any) => {
            mainContractList = respond.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber));
            setMainContractList(mainContractList)

            mainContractTempList = respond
            setMainContractTempList(mainContractTempList)

            mainContractCount = respond?.length ?? 0
            setMainContractCount(mainContractCount)

            seteditModeReleaseSplits(!editModeReleaseSplits);

            selectSplit = ""
            setselectSplit(selectSplit)

        })

    }

    const paginationContacts = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        mainContractList = mainContractTempList.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber));
        setMainContractList(mainContractList)
    }

    const search_forListing = (event: any) => {
        searchFor = event
        setSearchFor(searchFor)

        var objectSearch = mainContractTempList?.filter((values: any) =>
            values?.contractTitle?.includes(event)
            || values?.catLogNumber?.includes(event)
            || values?.contractRefNum?.includes(event)
            || values?.releaseTitle?.includes(event)
        )

        mainContractList = objectSearch.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber));
        setMainContractList(mainContractList)
    }

    const onChangReleaseLinkDetail = (event: any) => {
        selectedValue = []
        setSelectedValue(selectedValue)
        ReleaseLinkDetailOpen = false
        setReleaseLinkDetailOpen(ReleaseLinkDetailOpen)
    }

    const releaseListingView = (e: any) => {
        console.log(e)
        selectedValue = e
        setSelectedValue(selectedValue)
        ReleaseLinkDetailOpen = true
        setReleaseLinkDetailOpen(ReleaseLinkDetailOpen)
    }

    const ZeroPayout = (contractAssociatedRelease: any) => {

        const payload = contractAssociatedRelease;
        if (payload?.contractSplit) {
            payload.contractSplit = 0;
        }

        if (payload?.automaticUpd) {
            payload.automaticUpd = 0;
        }

        ReleaseService.mainContractsSave(payload).then((respond: any) => {
            mainContractList = respond.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber));
            setMainContractList(mainContractList)

            mainContractTempList = respond
            setMainContractTempList(mainContractTempList)

            mainContractCount = respond?.length ?? 0
            setMainContractCount(mainContractCount)
        })
    }

    const saveReleaseContractListings = () => {
        freezeAsset = !freezeAsset
        setfreezeAsset(freezeAsset)
        ReleaseService.ContractReportingSave({ contractRefNum: param?.contractDetails?.contractRefNum, freezeAsset: freezeAsset ? 1 : 0 }).then((respond: any) => {
            apiCall();
        })
    }

    const sliderChange = (mapValue: any) => {
        mapValue.automaticUpd = !mapValue?.automaticUpd;
        saveReleaseSplitsSlider(mapValue);
    }

    return (<>
        <Drawer open={param.ReleaseLinkingOpen} onClose={closeDrawer} direction='right' className='react-drawer allowHscroll allowVscroll' size={800}>

            <div className="ws-9 pull-right box">
                <div className='ws-12 landing'>

                    <div className="box-header-main">  <h2>Release Linking</h2>  </div>

                    <div className="box-content">
                        <div className="ws-12">

                            <fieldset className="scheduler-border p0 m0">
                                <legend className="scheduler-border">
                                    <h2 style={{ color: "#47529d;" }}> <i className="fa fa-sticky-note-o"></i> Contract Info  </h2>
                                </legend>
                                <form className="form-horizontal form-condensed  row-fluid ng-pristine ng-valid" name="songform">
                                    <div className="ws-12">

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-4 text-right pr" >  Contract Code :  </label>
                                                <div className="label-entries ws-8"> {param?.contractDetails?.contractRefNum}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-4 text-right pr" > Contract Title : </label>
                                                <div className="label-entries ws-8"> {param?.contractDetails?.contractTitle}</div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-4 text-right pr" >  Contact : </label>
                                                <div className="label-entries ws-8"> {param?.contractDetails?.contractAccount} ({param?.contractDetails?.contractAccountCode})  </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </fieldset>

                        </div>

                        <div className="ws-12 mtll mbl">
                            <div className="pull-right">
                                <span className="pull-left pr">Freeze Contract Assets : </span>

                                <label className="switch">
                                    <input type="checkbox" checked={freezeAsset} onChange={saveReleaseContractListings} />
                                    {freezeAsset && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!freezeAsset && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>

                            </div>
                        </div>

                        <div className="box">
                            <div className="box-header">
                                <h2 >Linked Releases ({mainContractCount})</h2>
                            </div>
                            <div className="box-content">

                                <div className="ws-12 mbl">
                                    <input type="text" className="ws-7" placeholder="Search" value={searchFor} onChange={(e: any) => search_forListing(e.target.value)} id="release" />
                                </div>

                                {(searchFor.length > 0 && mainContractTempList.length == 0 && mainContractCount != 0) && <div className="alert mt mb hide">  No results found for these criterias </div>}

                                {mainContractCount != 0 && <div className="ws-12 mt">

                                    <table className="newTable">
                                        <thead>
                                            <tr>
                                                <th className='forceSingleLine'>Catalog</th>
                                                <th className='forceSingleLine'>Artist</th>
                                                <th className='forceSingleLine'>Title</th>
                                                <th className='forceSingleLine'>Region</th>
                                                <th className='forceSingleLine'>Cont Tracks</th>
                                                <th className='forceSingleLine'>Split</th>
                                                <th className='forceSingleLine'>Auto-Update</th>
                                                <th className='forceSingleLine'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                mainContractList?.map((mapValue: any) => {
                                                    return (

                                                        <tr >
                                                            <td >{mapValue?.catLogNumber}</td>
                                                            <td >{mapValue?.releaseArtist}</td>
                                                            <td >{mapValue?.releaseTitle}</td>
                                                            <td >{mapValue?.regionCode}</td>
                                                            <td >{mapValue?.contTracks}</td>
                                                            <td>
                                                                {selectSplit != mapValue?.splitId && <span className="pull-right">{mapValue?.contractSplit}</span>}
                                                                {editModeReleaseSplits && selectSplit == mapValue?.splitId && <div>
                                                                    <input type="text" value={selectcontractSplit} className='ws-7' onChange={(e: any) => setselectcontractSplit(e.target.value)} />
                                                                    <button type="button" className="icon-btn edit height35" onClick={() => saveReleaseSplitsSlider(mapValue)} title="Save">  <i className="icon-save"></i>   </button>
                                                                    <button type="button" className="icon-btn delete height35" onClick={() => { editSplit(mapValue) }} title="Cancel">  <i className="icon-cancel1"></i>  </button>
                                                                </div>}

                                                            </td>
                                                            <td>
                                                                <label className="switch mts mbs">
                                                                    <input type="checkbox" checked={mapValue?.automaticUpd} onChange={() => sliderChange(mapValue)} />
                                                                    {mapValue?.automaticUpd && <span className="slider round text-left white pm pts">Yes</span>}
                                                                    {!mapValue?.automaticUpd && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <div className='width200'>

                                                                    <a className="icon-btn info" onClick={() => ZeroPayout(mapValue)}>Zero Payout</a>
                                                                    <a className="icon-btn info" onClick={() => releaseListingView(mapValue)}>View</a>
                                                                    <a className="icon-btn edit" onClick={() => { editSplit(mapValue) }} >Edit</a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                </div>}

                                {mainContractCount > 10 && <div className="box-footer mtl p0">
                                    <Pagination onPageChange={paginationContacts} totalRow={mainContractCount} />

                                </div>}

                            </div>

                            <div className="box-footer">
                                <button className="icon-btn delete width100 height35" onClick={closeDrawer}>Close </button>
                            </div>
                        </div>

                    </div>
                </div>

                {
                    (() => {
                        if (ReleaseLinkDetailOpen) {
                            return <ReleaseLinkDetails onChangReleaseLinkDetail={onChangReleaseLinkDetail} ReleaseLinkDetailOpen={ReleaseLinkDetailOpen} selectedValue={selectedValue} />
                        }
                    })()
                }
            </div>

        </Drawer></>

    )
}